import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdCopyTargetAppGroupIdCacheKeys } from "./constants";
import type {
  PostGenerativeAiAgentIdCopyTargetAppGroupIdProps,
  GenerativeAiAgentIdCopyTargetAppGroupIdResult,
  GenerativeAiAgentIdCopyTargetAppGroupIdResultErrors,
} from "./types";

/** POST handler for the "/generative_ai/agent/:id/copy/:target_app_group_id" endpoint */
export const postGenerativeAiAgentIdCopyTargetAppGroupId = reactQueryMutationAdapter(
  generativeAiAgentIdCopyTargetAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<GenerativeAiAgentIdCopyTargetAppGroupIdResultErrors>()(
    ({
      id,
      target_app_group_id: targetAppGroupId,
    }: PostGenerativeAiAgentIdCopyTargetAppGroupIdProps): Promise<GenerativeAiAgentIdCopyTargetAppGroupIdResult> => {
      return fetch(`/generative_ai/agent/${id}/copy/${targetAppGroupId}`, "POST", {}, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
